var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAppCrashes = function SvgAppCrashes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.84 17c.35.63.14 1-.6 1H1.74c-.7 0-.92-.37-.57-1l7.8-14c.35-.64.73-.64 1.07 0l7.8 14zM8.1 2.5l-7.82 14C-.44 17.8.26 19 1.75 19h15.5c1.5 0 2.2-1.2 1.47-2.5l-7.8-14c-.74-1.3-2.1-1.3-2.83 0zM9 13h1V7H9v6zm0 3h1v-1H9v1z"
  })));
};
export default SvgAppCrashes;